import { GitBranch } from '@phosphor-icons/react';

export default GitBranch;
